export const formatNumber = (value: number): string => {
  return new Intl.NumberFormat('en-US').format(value);
};

export const unformatNumber = (value: string): number => {
  return Number(value.replace(/,/g, ''));
};